import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {CONFIGURATION_INITIALIZER} from "../../initializers/ActiveBrandInitializer";
import {IPromise} from "angular";
import {Principle} from "../brand_service/model/Principle";
import {USER_SETTINGS_INITIALIZER} from "modules/user_settings/UserSettingsInitializer";

export class PrincipalUtil {
    static hasAuthorityPromise(authorityName: UserGranredAuthorityName): IPromise<boolean> {
        return this.getPrinciple()
            .then(principal => {
                return principal.userAccessLevels
                    .find(featureAccess => featureAccess.authorityName === authorityName)
                    .status;
            });
    }

    static getPrinciple(): Promise<Principle> {
        return CONFIGURATION_INITIALIZER.getPrinciple();
    }

    static getSettings(): Promise<Object> {
        return USER_SETTINGS_INITIALIZER.fetchSettings();
    }

    static getSmsSettings(): Promise<Object> {
        return USER_SETTINGS_INITIALIZER.fetchSmsSettings();
    }
}
